import { FunctionComponent, PropsWithChildren } from 'react';

import { FormControl, Grid } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { BaseDateTimePicker } from '../../../../../../shared/components/base-date-time-picker/base-date-time-picker';
import BaseFormInputField from '../../../../../../shared/components/base-input-form-field/base-form-input-field';
import { setDateInputValue } from '../../../../utils/set-date-input-value/set-date-input-value.util';
import { BasicInfoFormikModel } from '../../models/basic-info-formik.model';
import { BasicInfoComponentProps } from '../../types/basic-info-component.props';

export const DateRangeInput: FunctionComponent<BasicInfoComponentProps> = (
  props: PropsWithChildren<BasicInfoComponentProps>
) => {
  const { values, setFieldValue, errors, touched, setFieldTouched } = props;

  const setStartDate = setDateInputValue<BasicInfoFormikModel>(
    setFieldValue,
    'startDate'
  );

  const setEndDate = setDateInputValue<BasicInfoFormikModel>(
    setFieldValue,
    'endDate'
  );

  return (
    <FormControl data-testid="date-range-input-form-control">
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <BaseDateTimePicker
              value={values.startDate || null}
              onChange={setStartDate}
              onAccept={() => setFieldTouched('startDate', true)}
              renderInput={params => (
                <BaseFormInputField
                  {...params}
                  className="date-time-picker-input-field"
                  label="From"
                  error={!!errors.startDate && touched.startDate}
                  onBlur={() => setFieldTouched('startDate', true)}
                  helperText={
                    !!errors.startDate && touched.startDate && errors.startDate
                  }
                  InputLabelProps={{ required: true }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <BaseDateTimePicker
              value={values.endDate ?? null}
              onChange={setEndDate}
              onAccept={() => setFieldTouched('endDate', true)}
              minDate={new Date()}
              renderInput={params => (
                <BaseFormInputField
                  {...params}
                  className="date-time-picker-input-field"
                  label="Until"
                  error={!!errors.endDate && touched.endDate}
                  onBlur={() => setFieldTouched('endDate', true)}
                  helperText={
                    !!errors.startDate && touched.endDate && errors.endDate
                  }
                  InputLabelProps={{ required: true }}
                />
              )}
            />
          </Grid>
        </Grid>
      </LocalizationProvider>
    </FormControl>
  );
};
